import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  fetchAppLogo(context, vm) {
    var storage = firebase.storage();
    var storageRef = storage.ref();

    var imgRef = storageRef.child("settings/app_logo.png");

    imgRef
      .getDownloadURL()
      .then(function(url) {
        context.commit("SET_IMAGE_DATA_PATH", url);
        vm.logoImage = url;
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  fetchBrowserIcon(context, vm) {
    var storage = firebase.storage();
    var storageRef = storage.ref();

    var imgRef = storageRef.child("settings/browser_icon.png");

    imgRef
      .getDownloadURL()
      .then(function(url) {
        context.commit("SET_BROWSER_IMAGE_DATA_PATH", url);
        //  vm.logoImage = url
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  addAppLogo(context, payload) {
    const fileName = "app_logo.png";
    const storageRef = firebase.storage().ref();
    const uploadTask = storageRef.child("settings/" + fileName).put(payload.imageDataFile);
    context.commit("SET_IMAGE_DATA", payload.imageData);

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {},
      (error) => {
        console.log("[App Logo] Error when uploading App Logo File:", error.code);
        payload.vm.$vs.loading.close();
        payload.vm.$vs.notify({
          time: 6000,
          title: "Update App Logo",
          text: error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      },
      () => {
        payload.vm.$vs.loading.close();
        payload.vm.$vs.notify({
          time: 6000,
          title: "Update App Logo",
          text: "Succeed",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          context.commit("SET_IMAGE_DATA_PATH", downloadURL);
        });
      }
    );
  },

  addBrowserIcon(context, payload) {
    const fileName = "browser_icon.png";
    const storageRef = firebase.storage().ref();
    const uploadTask = storageRef.child("settings/" + fileName).put(payload.imageDataFile);
    context.commit("SET_BROWSER_IMAGE_DATA", payload.imageData);

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {},
      (error) => {
        console.log("[App Logo] Error when uploading App Logo File:", error.code);
        payload.vm.$vs.loading.close();
        payload.vm.$vs.notify({
          time: 6000,
          title: "Update App Logo",
          text: error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      },
      () => {
        payload.vm.$vs.loading.close();
        payload.vm.$vs.notify({
          time: 6000,
          title: "Update App Logo",
          text: "Succeed",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          context.commit("SET_BROWSER_IMAGE_DATA_PATH", downloadURL);
        });
      }
    );
  },
};
